﻿import { BreakpointTool as BreakpointToolExternal } from '@basic-orange/breakpointtool';

class BreakpointTool extends BreakpointToolExternal {
    constructor(elm, componentId) {
        super(elm, componentId);
    }
}

export default BreakpointTool;